import { usePdfAsImage } from 'features/knowledgeDocumentViewer/components/viewer/image/hooks/usePdfAsImage'
import { useCantileverPageHostsOptional } from 'features/knowledgeDocumentViewer/contexts/CantileverPageHostsContext'
import { resolvePageImageFileRefDual } from 'features/knowledgeDocumentViewer/utils/documentPageImages'
import { useRolodexSignedURLs } from 'features/rolodex'
import { useMemo } from 'react'

interface UsePageThumbnailUrlResult {
  url: string | undefined
  isLoading: boolean
}

export function usePageThumbnailUrl(
  documentId: string,
  pageNumber: number,
  pdfUrl?: string,
  totalPages = 1
): UsePageThumbnailUrlResult {
  const pageHosts = useCantileverPageHostsOptional()
  const pageHostId = pageHosts?.getCantileverPageHostId(pageNumber)
  const query = useMemo(
    () =>
      resolvePageImageFileRefDual(
        documentId,
        pageNumber,
        'thumbnail',
        pageHostId
      ),
    [documentId, pageHostId, pageNumber]
  )

  const { url, isLoading: isUrlLoading } = useRolodexSignedURLs(query)

  const thumbnail404 = !isUrlLoading && !url
  const pdfFallbackEnabled = thumbnail404 && !!pdfUrl
  const { imageUrl: pdfImageUrl, isLoading: isPdfLoading } = usePdfAsImage(
    pdfFallbackEnabled ? pdfUrl : undefined,
    pageNumber,
    1,
    totalPages,
    pdfFallbackEnabled
  )

  return {
    url: url ?? pdfImageUrl ?? undefined,
    isLoading: isUrlLoading || (pdfFallbackEnabled && isPdfLoading),
  }
}
